module.exports = __webpack_public_path__ + "media/30.4cbd5a80.mp3";